module.exports = __webpack_public_path__ + "startpage-746fed5a/template-6-2x-1e673c1fdba65ea306a49e294dc09e8a.jpg";